import { render, staticRenderFns } from "./SecurityRoles.vue?vue&type=template&id=5a6cbe9e&scoped=true"
import script from "./SecurityRoles.vue?vue&type=script&lang=js"
export * from "./SecurityRoles.vue?vue&type=script&lang=js"
import style0 from "./SecurityRoles.vue?vue&type=style&index=0&id=5a6cbe9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6cbe9e",
  null
  
)

export default component.exports